import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'

/**
 * Подсветка зоны перетаскивания файлов поверх ленты. Общая для страницы чата
 * и панели чата урока — иначе drag-and-drop выглядел бы в них по-разному.
 */
export function ChatDropOverlay() {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'action.hover',
        border: 2,
        borderColor: 'primary.main',
        borderStyle: 'dashed',
        borderRadius: 1,
        pointerEvents: 'none',
      }}
    >
      <Typography color="primary" fontWeight={600}>
        {t('chat.dropToAttach')}
      </Typography>
    </Box>
  )
}
